(function() {
  const isCollectionPage = window.location.pathname.includes('/collections/') || window.location.pathname.includes('/search') && 
                            !window.location.pathname.includes('/products/');
  
  if (!isCollectionPage) return;

  const isB2BCustomer = window.isB2BCustomer || false;
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const hasVisibilityFilters = searchParams.has('filter.p.m.custom.visible_b2b') || 
                                 searchParams.has('filter.p.m.custom.visible_b2c');
  
  // function hideVisibilityParamsInUrl() {
  //   try {
  //     const loc = new URL(window.location.href);
  //     const params = loc.searchParams;
  //     const before = params.toString();
  //     params.delete('filter.p.m.custom.visible_b2b');
  //     params.delete('filter.p.m.custom.visible_b2c');
  //     const after = params.toString();
  //     if (before !== after) {
  //       const cleanUrl = loc.pathname + (after ? ('?' + after) : '') + loc.hash;
  //       if (window.history && typeof window.history.replaceState === 'function') {
  //         window.history.replaceState(null, '', cleanUrl);
  //       }
  //     }
  //   } catch (_) {}
  // }

  // function hideVisibilityActiveChips() {
  //   try {
  //     const selectors = [
  //       'a[href*="filter.p.m.custom.visible_b2b"]',
  //       'a[href*="filter.p.m.custom.visible_b2c"]'
  //     ];
  //     document.querySelectorAll(selectors.join(',')).forEach((removeLink) => {
  //       const chip = removeLink.closest('[data-active-filter], .active-facet, li, .facet-remove');
  //       if (chip && chip.parentElement) chip.parentElement.removeChild(chip);
  //     });
  //   } catch (_) {}
  // }

  // function hideVisibilityParams() {
  //   hideVisibilityParamsInUrl();
  //   hideVisibilityActiveChips();
  // }

  if (hasVisibilityFilters) {
    // hideVisibilityParams();
    return;
  }

  if (isB2BCustomer) {
    searchParams.set('filter.p.m.custom.visible_b2b', '1');
  } else {
    searchParams.set('filter.p.m.custom.visible_b2c', '1');
  }

  const newUrl = currentUrl.pathname + '?' + searchParams.toString();
  
  window.location.replace(newUrl);
  // try {
  //   if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate) {
  //     FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, function() {
  //       hideVisibilityParams();
  //     });
  //   } else {
  //     window.addEventListener('popstate', hideVisibilityParams);
  //   }
  // } catch (_) {}
})();

